import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';

const ROW_HEIGHT = 58;

export const Column = styled.td`
  height: ${ROW_HEIGHT}px;
  > a,
  > button {
    padding: 0 10px;
    ${media.smallOnly`
      padding: 0 2px;
    `}
  }
  > .pj-ui-popover--wrapper {
    display: block;
    width: 100%;
    height: 100%;
  }
  ${p =>
    p.expandOnMobile &&
    media.mediumDown`
      width: 100%;
    `}
  ${p =>
    p.expand &&
    css`
      width: 100%;
    `}
`;

export const Link = styled.a`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  outline: none;
  ${p =>
    p.alignCenter &&
    css`
      justify-content: center;
    `}
  ${p =>
    p.alignLeft &&
    css`
      justify-content: flex-start;
    `}
  ${p =>
    p.alignRight &&
    css`
      justify-content: flex-end;
    `}
`;

const rowStyles = css`
  width: 100%;
  line-height: 1.3em;
  position: relative;
  > td {
    border-bottom: 1px solid ${p => p.theme.lines.primary};
  }

  ${props =>
    props.noExternalUri &&
    css`
      cursor: default;
    `}

  ${props =>
    props.nonFeatured &&
    css`
      color: ${p => p.theme.text.secondary};
      &:hover {
        color: ${p => p.theme.text.secondary};
      }
    `}

  ${media.smallOnly`
      &:last-child {
        border-bottom: 1px solid ${p => p.theme.lines.primary};
      }
    }
  `}

  ${props =>
    props.reportButtonRow &&
    css`
      width: 100%;
      height: 0;
      > td {
        height: 0;
        border-bottom: 0;
      }
      > ${Column} {
        width: 100%;
        > div {
          position: relative;
          width: 100%;
          height: 0;
          > div {
            height: ${ROW_HEIGHT - 1}px;
            left: 110px;
            top: auto;
            bottom: 1px;
            ${media.smallOnly`
              left: 0;
              padding-right: 40px;
            `}
          }
        }
      }
    `}
`;

export const Row = styled.tr`
  ${rowStyles}
  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
`;

export const InfoRow = styled.tr`
  ${rowStyles}
  background-color: rgba(0, 0, 0, 0.03);
  > td {
    flex: 0 0 100%;
  }
`;

export const AltRow = styled.tr`
  ${rowStyles}
  background-color: rgba(0, 0, 0, 0.03);
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;
